import { toMillis } from '@bridebook/toolbox/src/time-utils/time-utils';

export const ARTICLES_PER_PAGE = 7;

/**
 * Default cache time for articles queries
 */
export const ARTICLES_QUERY_CACHE_TIME = toMillis(15, 'min');
